module.exports = __webpack_public_path__ + "static/media/BMWi_EnEffi_logo @2x.b09754b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/infopanel/BMWi_EnEffi_logo @2x.png
// module id = 467
// module chunks = 0